import { render, staticRenderFns } from "./prepositioner-som-styr-dativ.vue?vue&type=template&id=7281eaa8&scoped=true"
import script from "./prepositioner-som-styr-dativ.vue?vue&type=script&lang=js"
export * from "./prepositioner-som-styr-dativ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7281eaa8",
  null
  
)

export default component.exports